var map = {
	"./cs.json": 113,
	"./de.json": 114,
	"./en.json": 115,
	"./hu.json": 116,
	"./pl.json": 117,
	"./pt.json": 118,
	"./sk.json": 119,
	"./sv.json": 120
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 183;



//////////////////
// WEBPACK FOOTER
// ./lang ^\.\/.*\.json$
// module id = 183
// module chunks = 3